// extracted by mini-css-extract-plugin
export default {"button":"Button_button__SG19R","hover_break":"Button_hover_break__GKJ2V","loading_spinner":"Button_loading_spinner__XFnaq","spin":"Button_spin__k-4GZ"};